// @flow
import React from 'react';
import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { Icon } from '@elements';
import { useTranslationNs } from '@helpers/helpers';
import './BlockedAccountNotice.scss';

type Props = {
  // Ajustes also says what is still open there; Meu plano only why the rest is closed
  place: 'settings' | 'plan',
};

// Why the agenda, the patients and the reports send a blocked account back (the gate in AuthenticatedRoute):
// shown on the pages it can still open. Nothing about prices, so it is the same in App Store review.
const BlockedAccountNotice = ({ place }: Props) => {
  const [_] = useTranslationNs('my_plan');
  const blocked = useSelector(state => get(state, ['context', 'user', 'advancedData', 'blocked'], false));
  const trialEnded = useSelector(state => get(state, ['context', 'user', 'advancedData', 'subscriptionStatus']) === 'end_of_trial');
  // A secretary or an invited doctor: the clinic owner's subscription is what's missing
  const dependent = useSelector(state => get(state, ['context', 'user', 'advancedData', 'isDependent'], false));

  if (!blocked) return null;

  let title = trialEnded ? _('blocked_notice/trial_title') : _('blocked_notice/title');
  if (dependent) title = _('blocked_notice/dependent_title');

  return (
    <div className="blockedAccountNotice" role="status">
      <Icon iconName="lock" size={18} className="blockedAccountNotice-icon" />
      <div>
        <strong>{title}</strong>
        <p>{_(`blocked_notice/${dependent ? 'dependent_' : ''}${place}`)}</p>
      </div>
    </div>
  );
};

export default BlockedAccountNotice;
